import React, { Fragment, useState,useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { Col, Form, FormGroup, Label, Row } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import {
  AfterNo,
  BeforeNo,
  Comma,
  Dash,
  DateFive,
  DateFormate,
  DateFour,
  DateOne,
  DateSix,
  DateThree,
  DateTwo,
  Decimal,
  Dot,
  FinancialYearStart,
  Next,
  PerPosition,
  Separator,
  Slash,
  Space,
  TimeZone,
} from "../../../../Constant";
import Typeahead from "../../../../CommonElements/TypeAhead/index";
import DatePicker from 'react-datepicker';
import moment from "moment";
import { useSelector } from "react-redux";
import { getClientUrlDataToken } from "../../../../Utils/restUtils";
import { getTimezoneSelect, getTimezoneSelectRole } from "../../../../CommonUrl";

const Formstep2 = ({ setSteps, setFormdata, formdata }) => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm();
  const authState = useSelector((state) => state.auth);
  const [timezoneOptions, setTimezoneOptions] = useState([]);
  const [financialDate, setFinancialDate] = useState(formdata.financial);

  const handleChangeDate = date => {
    setFinancialDate(date);
  };
  
  const dateFormat = [
    { value: "d M Y", label: DateOne },
    { value: "M d Y", label: DateTwo },
    { value: "Y M d", label: DateThree },
    { value: "d m Y", label: DateFour },
    { value: "m d Y", label: DateFive },
    { value: "Y m d", label: DateSix },
]


  const decimaloptions = [
    { value: "2", label: "0.00" },
    { value: "3", label: "0.000" },
    { value: "4", label: "0.0000" },
  ]


  const dateSeperator = [
    { value: "-", label: Dash },
    // { value: "/", label: Slash },
    { value: ".", label: Dot },
    // { value: ",", label: Comma },
    // { value: " ", label: Space },
  ]
  const percentPosition = [
    { value: "after", label: AfterNo },
    { value: "before", label: BeforeNo },
  ]
  const monthOptions = [
    { value: "January", label: "January" },
    { value: "February", label: "February" },
    { value: "March", label: "March" },
    { value: "April", label: "April" },
    { value: "May", label: "May" },
    { value: "June", label: "June" },
    { value: "July", label: "July" },
    { value: "August", label: "August" },
    { value: "September", label: "September" },
    { value: "October", label: "October" },
    { value: "November", label: "November" },
    { value: "December", label: "December" },
  ];
  const getFinancialMonth = (financial) => {
  if (!financial) return { value: "January", label: "January" };
  if (financial.value) return financial;

  const selectedMonth = monthOptions.find(
    (month) => month.value === financial || month.label === financial
  );
  if (selectedMonth) return selectedMonth;

  const financialDate = new Date(financial);
  if (!Number.isNaN(financialDate.getTime())) {
    return monthOptions[financialDate.getMonth()];
  }

  return { value: "January", label: "January" };
};

  useEffect(() => {
    setValue("time", {
      value: formdata?.time?.value,
      label: formdata?.time?.label,
    });

    const timezoneApi = async () => {
      const data = await getClientUrlDataToken(
        authState.apiUrl,
        authState.userRole === 1 ? getTimezoneSelect : getTimezoneSelectRole
      );
      if (data?.status === true && Array.isArray(data?.data)) {
        const transformedData = data.data.map((item) => {
          if (typeof item === "string") return { label: item, value: item };
          return {
            label: item.label || item.name || item.timezone || item.value || "",
            value: item.value || item.id || item.timezone || item.name || "",
          };
        });
        setTimezoneOptions(transformedData);
      }
    };
    timezoneApi();
  }, [authState]);


  const onSubmit = (data) => {
    if (data) {
      const financialVal = data.financial_year?.value || data.financial_year?.label || data.financial_year || formdata.financial || "";
      setFormdata((prev) => ({ ...prev, ...data, financial: financialVal, financial_year: financialVal }));
      setSteps((pre) => pre + 1);
    }
  };
  return (
    <Fragment>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="form-bookmark needs-validation"
      >
        <Row className="g-3 pt-3">
          <Col md="6">
            <FormGroup className="mb-3">
              <Label htmlFor="financial">{FinancialYearStart}</Label>
              <Controller
                name="financial_year"
                control={control}
                defaultValue={getFinancialMonth(formdata.financial)}
                render={({ field }) => (
                  <Typeahead
                    id="financial"
                    options={monthOptions}
                    onChange={(value) => {
                      field.onChange(value);
                    }}
                    value={field.value}
                    placeholder="Select Month"
                  />
                )}
              />
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup className="mb-3">
              <Label>{TimeZone}</Label>
              <Controller
                name="timezone"
                control={control}
                defaultValue={formdata.timezone || ""}
                render={({ field }) => (
                  <Typeahead
                    options={timezoneOptions}
                    onChange={(value) => {
                      field.onChange(value);
                    }}
                    value={field.value}

                  />
                )}
              />

            </FormGroup>
          </Col>
        </Row>
        <Row className="g-3">
          <Col md="6">
            <FormGroup className="mb-3">
              <Label >{DateFormate}</Label>
              <Controller
                name="dateFormate"
                control={control}
                defaultValue={formdata.dateFormate || ""}

                render={({ field }) => (
                  <Typeahead
                    options={dateFormat}
                    onChange={(value) => {
                      field.onChange(value);
                    }}
                    value={field.value}

                  />
                )}
              />

            </FormGroup>
          </Col>
          <Col md="6">
            <Label >{Separator}</Label>
            <Controller
              name="separator"
              control={control}
              defaultValue={formdata.separator || ""}

              render={({ field }) => (
                <Typeahead
                  options={dateSeperator}
                  onChange={(value) => {
                    field.onChange(value);
                  }}
                  value={field.value}

                />
              )}
            />

          </Col>
        </Row>
        <Row className="g-3 ">
          <Col md="6">
            <Label >{PerPosition}</Label>
            <Controller
              name="position"
              control={control}
              defaultValue={formdata.position || ""}

              render={({ field }) => (
                <Typeahead
                  options={percentPosition}
                  onChange={(value) => {
                    field.onChange(value);
                  }}
                  value={field.value}

                />
              )}
            />

          </Col>
          <Col md="6">
            <Label >{Decimal}</Label>
            <Controller
              name="decimal"
              control={control}
              defaultValue={formdata.decimal || decimaloptions[0]}
              render={({ field }) => (
                <Typeahead
                  options={decimaloptions}
                  onChange={(value) => {
                    field.onChange(value);
                  }}
                  value={field.value}

                />
              )}
            />

          </Col>


        </Row>
        <div className="text-end">
          <Btn attrBtn={{ color: "primary", type: "submit" }}>{Next}</Btn>
        </div>
      </Form>
    </Fragment>
  );
};

export default Formstep2;
